export default __webpack_public_path__ + "static/media/🦆 icon _lock_.607ee69d.svg";